import { IonPage } from '@ionic/react';
import styled from 'styled-components';

export const PaywallV2Styles = styled(IonPage)`
  body.dark & {
    ion-content {
      --background: linear-gradient(
        360deg,
        #2b0e21 0%,
        #14111e 49.18%,
        #1e0f34 100%
      );
      background: linear-gradient(
        360deg,
        #2b0e21 0%,
        #14111e 49.18%,
        #1e0f34 100%
      );
    }
  }

  padding-top: 65px;

  ion-content {
    --background: #fff;
    background: #fff;

    .title {
      font-weight: 700;

      &--red {
        color: #fe1b74;
      }
    }
  }
`;
